
<template>
  <v-data-table :loading="loading" 
  :headers="headers" :items="Product" :sort-by="sortBy"
    hide-default-footer :items-per-page="Product.length">
    <template v-slot:item="{ item }">
      <tr class="pointer">
        <td class="text-left small-td pointer">{{ item.ProductName }}</td>

        <td class="text-center small-td pointer">{{ parseInt(item.Quantity) }}</td>
        <td class="text-right small-td pointer">{{ item.SaleAmount | currency }}</td>
        <td class="text-right small-td pointer">{{ item.CostAmount | currency }}</td>
        <td class="text-right small-td pointer">{{ item.DetailDiscount | currency }}</td>
        <td class="text-right small-td pointer" :class="foreColor(item.profit)">{{ item.profit | currency }}</td>

      </tr>
    </template>

  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex'
import reportService from '@/pages/Report/service.js'

export default {
  name: 'product-list',
  props: ['dateTime','location','subCategory'],
  data() {
    return {
      loading: false,
      selectedDate: null,
      Product: [],
      sortBy: "SubCategoryName",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Name',
          align: "left",
          sortable: true,
          value: "ProductName"
        },
        {
          text: 'Quantity',
          align: "center",
          sortable: true,
          value: "Quantity"
        },
        {
          text: 'Sale Amount',
          align: "right",
          sortable: true,
          value: "SaleAmount"
        },

        {
          text: 'Cost of goods',
          align: 'right',
          value: "CostAmount",
          sortable: true
        },
        {
          text: 'Discount',
          align: 'right',
          value: "DetailDiscount",
          sortable: true
        },
        {
          text: 'Profit',
          align: 'right',
          value: "profit",
          sortable: true
        },

      ],
    }
  },
  watch: {
    location(val) {
      // this.setSelectedLocation(val)
      this.getProductList()
    }
  },
  created() {
    this.getProductList()
    // console.log('$route.params', this.$route.params)
    // if (this.$route.params.location) {
    //   this.location = this.$route.params.location
    //   this.dateTime = this.$route.params.dateTime
    //   this.mainCategory = this.$route.params.category.MainCategoryID

    //   this.getSubCategory()
    // } else {
    //   if (this.selectedLocation) {
    //     this.location = this.selectedLocation
    //   }
    // }
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation']),
    foreColor(val) {
      let color = 'black--text'
      if (val < 0) {
        color = 'red--text'
      }
      return color
    },
    getProductList() {
      console.log('getProductList')
      this.Product = []
      this.loading = true
      return reportService
        .getProduct(this.location.storeID, { subCategory: this.subCategory, from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          console.log("getProductList", response);
          this.loading = false
          this.Product = response.data
          this.Product.map(row => {
            row.profit = parseFloat(row.SaleAmount) - parseFloat(row.CostAmount) - parseFloat(row.DetailDiscount)
          })
          // this.setBatchList(this.Batches)
          return response;
        }).catch(error => {
          console.log('error', error)
          this.loading = false
        })

    }
  }
}
</script>

<style scoped>
</style>
